// extracted by mini-css-extract-plugin
export default {"footer":"classes_footer__7jcl5"};